import { z } from 'zod';
// Mirror of the Phase 10a Prisma enums. Adding a value here is a
// deliberate three-place change (Prisma enum + this schema + a
// passing test).
export const BuyerTypeSchema = z.enum(['FACILITY', 'HOMECARE_CLIENT']);
export const InvoiceStatusSchema = z.enum([
    'DRAFT',
    'ISSUED',
    'PARTIAL',
    'PAID',
    'OVERDUE',
    'DISPUTED',
    'VOIDED',
]);
export const InvoiceLineTypeSchema = z.enum([
    'SHIFT_BILL',
    'CANCELLATION_FEE',
    'INTEREST',
    'CREDIT_MEMO',
    'MANUAL_ADJUSTMENT',
]);
export const PaymentEventTypeSchema = z.enum([
    'STRIPE_CAPTURE',
    'STRIPE_REFUND',
    'STRIPE_DISPUTE',
    'CHEQUE',
    'EFT',
    'WIRE',
    'PAD',
    'MANUAL_CREDIT',
]);
export const DunningOutcomeSchema = z.enum(['SENT', 'BOUNCED', 'SUPPRESSED', 'FAILED']);
// ─────────────────────────────────────────────────────────────────────────────
// Phase 11a — payout-side enums (mirror Prisma model values exactly).
// ─────────────────────────────────────────────────────────────────────────────
/** Phase 11-5(a) — payout lifecycle. */
export const PayoutStatusSchema = z.enum(['DRAFT', 'ISSUED', 'PAID', 'VOIDED']);
/** Phase 11-3 — payout line semantic. */
export const PayoutLineTypeSchema = z.enum([
    'SHIFT_PAY',
    'STAT_HOLIDAY_PAY',
    'CANCELLATION_PAY',
    'BONUS',
    'MANUAL_ADJUSTMENT',
]);
/** Phase 11-2 — per-caregiver payout cadence. */
export const PayoutFrequencySchema = z.enum(['BIWEEKLY', 'WEEKLY']);
/** Phase 11a-7 — payout mechanic (bank-agnostic). */
export const PayoutMechanicSchema = z.enum(['EFT', 'INTERAC', 'CHEQUE_MAILED', 'MANUAL']);
/** Phase 11a-7 — payout event lifecycle (bank-agnostic). */
export const PayoutEventTypeSchema = z.enum([
    'EFT_DISPATCHED',
    'EFT_SETTLED',
    'EFT_REJECTED',
    'INTERAC_SENT',
    'CHEQUE_MAILED',
    'MANUAL_CREDIT',
    'REVERSAL',
]);
/** Phase 11-4 / 11a — change-action enum for caregiver_guarantee_policy mutations. */
export const CaregiverGuaranteePolicyChangeActionSchema = z.enum([
    'CREATED',
    'SUPERSEDED',
    'DEPRECATED',
]);
//# sourceMappingURL=enums.schema.js.map